import { DeleteOutlined, EditOutlined, PlusCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Card, Col, Flex, Input, message, Modal, Row, Table, Tag, Typography } from 'antd';
import React, { useEffect, useRef, useState } from 'react'
import Highlighter from 'react-highlight-words';
import { Link, useNavigate } from 'react-router-dom';
import api from '../../API';

function OAAccountList() {
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem('user'));
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [searchText, setSearchText] = useState('');
    const dataOnTable = useRef([]);
    const originalTableData = useRef([]);
    const columns = [
    {
        title: "Name",
        dataIndex: "accountName",
        width: 300,
        render: (text) =>
        searchText ? (
            <Highlighter
            highlightStyle={{
                backgroundColor: '#ffc069',
                padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
            />
        ) : (
            text
        )
    },
    {
        title: "OA ID",
        dataIndex: "OAId",
        render: (text) =>
        searchText ? (
            <Highlighter
            highlightStyle={{
                backgroundColor: '#ffc069',
                padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
            />
        ) : (
            text
        )
    },
    {
        title: "Phone number",
        dataIndex: "PhoneNumber",
        render: (text) =>
        searchText ? (
            <Highlighter
            highlightStyle={{
                backgroundColor: '#ffc069',
                padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
            />
        ) : (
            text
        )
    },
    {
        title: "Status",
        dataIndex: "status",
        render: (status) =>
            status ? (
            <Tag color="#87d068">
                {"Completed".toUpperCase()}
            </Tag>
        ) : (
            <Tag color="#f50">
                {"Disconnected".toUpperCase()}
            </Tag>
        )
    },
    ...((!user?.parentId) ? [{
        title: 'Action',
        key: 'action',
        width: 105,
        align: 'center',
        render: (_, record) => (
            <Flex justify="space-around" align="center">
                <Button 
                    type="primary" 
                    icon={<EditOutlined/>} 
                    onClick={() => navigate(
                        `/oaaccounts/edit`,
                        {state: originalTableData.current.find(obj => obj.id === record.key)}
                    )}>
                </Button>
                <Button 
                    type="primary" 
                    danger 
                    icon={<DeleteOutlined/>}
                    onClick={() => {
                        Modal.confirm({
                            title: 'Confirm deletion',
                            content: `Are you sure you want to delete this OA account?`,
                            onOk() {handleRemoveRow(record.key, record.OAId)},
                            maskClosable: true
                        })
                    }}>
                </Button>
            </Flex>
        ),
    }] : [])
    ];
    useEffect(() => {
        api.list_oaaccounts_by_user(user?.userId, user?.parentId, ["*"])
        .then(oaaccounts => {
            originalTableData.current = oaaccounts.concat();
            dataOnTable.current = oaaccounts.map(oaaccount => ({
                key: oaaccount.id,
                accountName: oaaccount?.accountName,
                OAId: oaaccount?.OAId,
                PhoneNumber: oaaccount?.PhoneNumber,
                status: oaaccount.AccessToken && oaaccount.RefreshToken && true
            }))
            setDataSource(dataOnTable.current); 
        })
        .catch((error) => message.error(error.message));
    },[])

    function handleSearchInfo(e) {
        if(e.target.value === '') {
          setSearchText(e.target.value);
          setDataSource(dataOnTable.current);
        }
        else {
          const searchData = dataOnTable.current.filter((o) => Object.keys(o).slice(1).some((k) => o[k] && String(o[k])
          .toLowerCase()
          .includes(e.target.value.toLowerCase())));
          setSearchText(e.target.value);
          setDataSource(searchData);
        }
      }

    async function handleRemoveRow(key, OAId) {
        try {
            setLoading(true);
            const response = await api.delete_oaaccount_byId(key, OAId, user?.userId);
            message.success(response.message);
            dataOnTable.current = dataOnTable.current.filter(record => record.key !== key);
            setDataSource(dataOnTable.current);
        } catch (error) {
            message.error(error.message);
        } finally {
            setLoading(false);
        }
    }
    
    return (
    <Card 
        style={{height: '100%', margin: "0 auto", boxShadow: "1px 1px 5px #ccc", borderRadius: 10 }}
        title={
            <Typography.Title level={5} style={{margin: 0}}>OA Account Management</Typography.Title>
        }
        loading={loading}
        extra={ !user?.parentId &&
            <Link to={`/oaaccounts/new`}>
                <Button type="primary" style={{padding:15}} icon={<PlusCircleOutlined/>}>
                    New OA
                </Button>
            </Link>
        }
    >
        <Row gutter={[16,16]}  align="middle">
            <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                <Input 
                    placeholder="Input search text"
                    allowClear
                    onChange={handleSearchInfo}
                    suffix={<SearchOutlined />}/>
            </Col>
        </Row>
        <Row>
            <Col span={24}>
                <Table  
                bordered
                scroll={{x: 1000}}
                columns= {columns} 
                style={{marginTop: 16, width: '100%'}} 
                dataSource={dataSource}
                loading={loading}
                pagination={{
                    position: ["bottomCenter"],
                    showSizeChanger: false, // Disable page size changer
                    pageSize: 10, 
                    showTotal: () => `Total: ${dataSource.length} items`
                }}
            />
            </Col>
        </Row>
    </Card>
    )
}

export default OAAccountList;
